<template>
    <div id="serviceContainer">
        <!-- 第一屏 -->
        <Screen1></Screen1>
        <!-- 子路由 -->
        <router-view></router-view>
    </div>
</template>

<script>
import Screen1 from '@/components/service/Screen1.vue'

export default {
    name: 'Service',
    components: {
        Screen1,
    },
    mounted(){
        this.$store.state.activeIndex = "/service"
    }
}
</script>

<style>
    .serviceTitle{
        width: 1120px;
        padding: 12.5px 0;
        margin: 0 auto;
    }
    .serviceTitle>span{
        display: inline-block;
        font-size: 16px;
        border-left: 2px solid #2d7be3;
        margin-left: 5px;
        text-indent: 10px;
        line-height: 20px;
    }
</style>
